/*!
 * @utiljs/dom 0.2.3 (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/dom/)
 * API http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/dom/doc/api.md
 * Copyright 2017-2020 美团mfe. All Rights Reserved
 * Licensed under MIT (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/dom/LICENSE)
 */

import { isElement } from '@utiljs/is';
import { error } from '@utiljs/console';

function hasClass(el, cls) {
  if (!isElement(el)) {
    error('@utiljs/dom#hasClass first param must is element');
    return false;
  }

  if (typeof cls === 'undefined') {
    error('@utiljs/dom#hasClass second param must is string');
    return false;
  }

  cls = String(cls);

  if (cls.indexOf(' ') !== -1) {
    error('@utiljs/dom#hasClass second param should not contain space');
    return false;
  }

  return " ".concat(el.className, " ").indexOf(" ".concat(cls, " ")) > -1;
}
function addClass(el, cls) {
  if (!isElement(el)) {
    error('@utiljs/dom#addClass first param must is element');
    return false;
  }

  if (typeof cls === 'undefined') {
    error('@utiljs/dom#addClass second param must is string');
    return false;
  }

  cls = String(cls);
  if (hasClass(el, cls)) return true;
  el.className += (el.className ? ' ' : '') + cls;
  return true;
}
function removeClass(el, cls) {
  if (!isElement(el)) {
    error('@utiljs/dom#removeClass first param must is element');
    return false;
  }

  if (typeof cls === 'undefined') {
    error('@utiljs/dom#removeClass second param must is string');
    return false;
  }

  cls = String(cls);
  if (!hasClass(el, cls)) return true;
  el.className = el.className.replace(cls, '');
  return true;
}
function toggleClass(el, cls) {
  if (!isElement(el)) {
    error('@utiljs/dom#toggleClass first param must is element');
    return false;
  }

  if (typeof cls === 'undefined') {
    error('@utiljs/dom#toggleClass second param must is string');
    return false;
  }

  cls = String(cls);
  return hasClass(el, cls) ? removeClass(el, cls) : addClass(el, cls);
}
function contains(wrapper, el) {
  if (!isElement(wrapper)) {
    error('@utiljs/dom#contains first param must is element');
    return false;
  }

  if (!isElement(el)) {
    error('@utiljs/dom#contains second param must is element');
    return false;
  }

  if (wrapper === el) {
    return true;
  }

  if (typeof wrapper.contains === 'function') {
    return wrapper.contains(el);
  }

  while (el = el.parentNode) {
    if (wrapper === el) {
      return true;
    }
  }

  return false;
}

export { hasClass, addClass, removeClass, toggleClass, contains };
